import { useState, useEffect } from 'react';
import { Button } from '../../common/buttons/Button';
import SVGIcon from '../../ui/Icons/SVGIcon';

import { Navigation, Keyboard } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { OfficePictureData } from '~/types/offices';
import { useTranslation } from 'react-i18next';
import { useLanguageParam } from '~/config/i18n';
import Badge, { Variant } from '~/components/common/badges/Badge';

type TProps = {
  images: OfficePictureData[];
  closeModal: () => void;
  open: boolean;
  title?: string;
  extraClass?: string;
  setActiveIndex?: (num: number) => void;
  activeIndex?: number;
  onNext?: () => void;
  onPrevious?: () => void;
};

const FullscreenGallery = ({
  images,
  closeModal: close,
  open = false,
  extraClass = '',
  setActiveIndex = () => {},
  onNext = () => {},
  onPrevious = () => {},
  activeIndex = 0,
}: TProps) => {
  // @ts-ignore
  const [swiperRef, setSwiperRef] = useState<Swiper>();

  const { t } = useTranslation();
  const lang = useLanguageParam();

  const prevSlide = () => {
    swiperRef.slidePrev();
  };

  const nextSlide = () => {
    swiperRef.slideNext();
  };

  useEffect(() => {
    const elem = document.body as HTMLDivElement;
    if (open) {
      elem.style.overflow = 'hidden';
    }
    return () => {
      elem.removeAttribute('style');
    };
  }, [open]);

  if (!open) return null;
  return (
    <div className={extraClass}>
      <div
        className="modal fade show"
        tabIndex={-1}
        style={{
          display: open ? 'block' : 'none',
        }}
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable m-0">
          <div className="modal-content border-0 rounded-0 h-100">
            <Button
              variant="primary"
              isIconButton={true}
              size="xxl"
              onClick={close}
              extraClasses={`position-absolute border-0 end-0 top-0 z-2 me-8 mt-8`}
            >
              <SVGIcon
                iconType="cross"
                style={{ stroke: 'white' }}
              />
            </Button>
            <div className="gallery-images mb-0">
              <Swiper
                modules={[Navigation, Keyboard]}
                spaceBetween={50}
                keyboard={{ enabled: true }}
                navigation={true}
                initialSlide={activeIndex}
                // @ts-ignore
                onInit={(swiper: Swiper) => {
                  setSwiperRef(swiper);
                }}
                slidesPerView={1}
                onSlideChange={(e) => {
                  if (activeIndex !== e.activeIndex) setActiveIndex(e.activeIndex);
                  if (activeIndex < e.activeIndex) onNext();
                  if (activeIndex > e.activeIndex) onPrevious();
                }}
              >
                {images.map((imageSource, index) => (
                  <SwiperSlide
                    key={`swiper-slide-${index}`}
                    className={'rounded-2'}
                  >
                    <img
                      loading="lazy"
                      src={imageSource.url}
                      className={'rounded-2'}
                      alt={imageSource.altDescription[lang]}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
            <span className="color-white top-0 position-relative m-auto pt-2 mt-0">
              {activeIndex > 0 && images[activeIndex].imageType !== 'other'
                ? t(`officeSearch.card.tags.gallery.${images[activeIndex].imageType}`)
                : ''}
            </span>
            <Button
              variant="primary"
              isIconButton={true}
              size="xxl"
              onClick={prevSlide}
              extraClasses={`position-absolute border-0 start-0 top-50 z-2 ms-8 d-none d-md-block ${
                activeIndex > 0 ? '' : 'd-md-none'
              }`}
            >
              <SVGIcon
                iconType="chevron-left"
                width="40"
                height="40"
              />
            </Button>

            <Button
              variant="primary"
              isIconButton={true}
              size="xxl"
              onClick={nextSlide}
              extraClasses={`position-absolute border-0 end-0 top-50 z-2 me-8 d-none d-md-block ${
                activeIndex + 1 < images.length ? '' : 'd-md-none'
              }`}
            >
              <SVGIcon
                iconType="chevron-right"
                width="40"
                height="40"
              />
            </Button>
            <Badge
              variant={Variant.PRIMARY}
              text={`${activeIndex + 1}/${images.length}`}
              extraClasses="rounded-3 position-absolute bottom-0 end-0 mb-8 me-8"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FullscreenGallery;

// <div className="modal-body">{children}</div>
// <div className="modal-footer">
//   <button
//     type="button"
//     className="btn btn-secondary"
//   >
//     Close
//   </button>
//   <button
//     type="button"
//     className="btn btn-primary"
//   >
//     Save changes
//   </button>

// </div>
